import { useInView } from '../../../hooks/useInView';

export default function Hero() {
  const { ref, inView } = useInView(0.05);

  return (
    <section id="home" className="relative w-full h-screen min-h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/images/hero.jpg"
          alt="Mastro Family Farm pastoral landscape at golden hour"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65" />
      </div>

      <div
        ref={ref}
        className={`relative z-10 flex flex-col items-center justify-center h-full text-center px-8 w-full transition-all duration-1200 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
        style={{ transitionDuration: '1200ms' }}
      >
        <p
          className="text-[#D4A84B] text-lg mb-5 tracking-[0.25em] uppercase"
          style={{ fontFamily: "'Dancing Script', cursive", fontSize: '1.3rem' }}
        >
          &#10022; Faith &nbsp;&middot;&nbsp; Family &nbsp;&middot;&nbsp; Harvest &#10022;
        </p>

        <h1 className="font-serif text-5xl md:text-7xl font-bold text-white leading-tight mb-5 drop-shadow-lg">
          Mastro Family Farm
        </h1>

        <p className="text-white/90 text-xl md:text-2xl font-light mb-4 max-w-2xl leading-relaxed drop-shadow">
          Stewarding God&apos;s Creation with Love &amp; Care
        </p>

        <p
          className="text-white/75 text-base mb-10 italic drop-shadow"
          style={{ fontFamily: "'Nunito', sans-serif" }}
        >
          &ldquo;The earth is the Lord&apos;s, and everything in it.&rdquo;&nbsp; Psalm 24:1
        </p>

        <div className="flex gap-4 flex-wrap justify-center">
          <button
            onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-10 py-4 bg-[#2C4A3B] hover:bg-[#3A5C4B] text-white text-sm font-semibold tracking-wider uppercase rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Our Story
          </button>
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-10 py-4 bg-white/15 hover:bg-white/25 border border-white/50 text-white text-sm font-semibold tracking-wider uppercase rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            Say Hello
          </button>
        </div>

        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/60 animate-bounce">
          <i className="ri-arrow-down-s-line text-3xl" />
        </div>
      </div>
    </section>
  );
}
